// PinnedNotification.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled, { createGlobalStyle } from 'styled-components';

import {
  pinnedNotificationOnDesktopHeight,
  pinnedNotificationOnTabletHeight,
  pinnedNotificationOnMobileHeight,
} from '../style/variables.js';
import { breakpoint } from '../style/variables.js';
import media from '../style/media.js';

const PinnedNotification = ({ children = null }) => {
  return (
    <PinnedNotificationWrapper>
      {children && <GlobalStyle />}
      {children}
    </PinnedNotificationWrapper>
  );
};

PinnedNotification.propTypes = {
  children: PropTypes.node,
};

const PinnedNotificationWrapper = styled.div`
  z-index: 50;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${pinnedNotificationOnDesktopHeight}px;

  display: flex;
  padding: var(--number-neutral-16, 16px) var(--number-neutral-72, 72px);
  align-items: center;
  gap: var(--number-neutral-16, 16px);

  @media (max-width: ${breakpoint.tablet}px) {
    top: 0;
    height: ${pinnedNotificationOnTabletHeight}px;
    bottom: unset;
    padding: var(--spacing-spacing-level4, 12px)
      var(--spacing-spacing-level5, 16px);
  }

  @media (max-width: ${breakpoint.mobile}px) {
    height: ${pinnedNotificationOnMobileHeight}px;
    padding: var(--spacing-spacing-level3, 8px)
      var(--spacing-spacing-level5, 16px);
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-spacing-level3, 8px);
  }

  background: var(
    --Gradient-live-private,
    linear-gradient(135deg, #ba39f3 0%, #5420a2 100%)
  );
`;

export const PinnedNotificationText = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  @media (max-width: ${breakpoint.mobile}px) {
    justify-content: start;
    width: 100%;
  }
`;

export const PinnedNotificationCTA = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--spacing-spacing-level3, 8px);
  @media (max-width: ${breakpoint.mobile}px) {
    justify-content: center;
    gap: 4px;
    width: 100%;
  }
`;

// (1)
// Use `html:root` instead of just `:root`.
// Otherwise the specificity would be lower than the rules set in App.jsx.
// (2)
// In most cases, this notification would cover elements on Desktop.
// However, the designer decides to push the chat input up a little bit,
// to make the input able to be seen by users (even though they can't send message under that circumstances)
const GlobalStyle = createGlobalStyle`
  html:root {
    --space-to-pinned-notification-even-on-desktop: ${pinnedNotificationOnDesktopHeight}px;
    ${media.tablet`
      --space-to-pinned-notification: ${pinnedNotificationOnTabletHeight}px;
      --space-to-pinned-notification-even-on-desktop: ${pinnedNotificationOnTabletHeight}px;
    `};
    ${media.mobile`
      --space-to-pinned-notification: ${pinnedNotificationOnMobileHeight}px;
      --space-to-pinned-notification-even-on-desktop: ${pinnedNotificationOnMobileHeight}px;
    `};
  }
`;

export default PinnedNotification;
